<script setup>
import { t } from '../i18n';

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  canSubmit: {
    type: Boolean,
    default: false,
  },
});

const name = defineModel('name', { type: String, default: '' });
const email = defineModel('email', { type: String, default: '' });
const password = defineModel('password', { type: String, default: '' });
const passwordConfirmation = defineModel('passwordConfirmation', { type: String, default: '' });

const emit = defineEmits(['submit']);
</script>

<template>
  <form
    class="space-y-3"
    @submit.prevent="emit('submit')"
  >
    <input
      v-model.trim="name"
      type="text"
      :placeholder="t('auth.name')"
      class="w-full rounded border border-slate-700 bg-slate-950 px-3 py-2"
      required
    >
    <input
      v-model.trim="email"
      type="email"
      :placeholder="t('auth.email')"
      class="w-full rounded border border-slate-700 bg-slate-950 px-3 py-2"
      required
    >
    <input
      v-model="password"
      type="password"
      :placeholder="t('auth.password')"
      class="w-full rounded border border-slate-700 bg-slate-950 px-3 py-2"
      required
    >
    <input
      v-model="passwordConfirmation"
      type="password"
      :placeholder="t('auth.passwordConfirmation')"
      class="w-full rounded border border-slate-700 bg-slate-950 px-3 py-2"
      required
    >
    <button
      class="rounded px-4 py-2 text-sm font-medium transition"
      :class="canSubmit && !loading ? 'bg-emerald-600 hover:bg-emerald-500' : 'bg-emerald-900/50 text-slate-400'"
      :disabled="loading || !canSubmit"
      type="submit"
    >
      {{ loading ? t('auth.sendingEmail') : t('auth.createAccount') }}
    </button>
  </form>
</template>
